import React, { useEffect, useState } from 'react';
import { Card, CardBody, Progress, Tooltip } from 'reactstrap';
import { IoIosArrowRoundDown } from "react-icons/io";
import { IoIosArrowRoundUp } from "react-icons/io";
import '../style/style.css';
import { errorToast } from '../../../../../../_helper/helper';
import AreaService from '../../../../../../api/areaService';

const NewBarChart2 = ({ progressData, filters, areaFlag, width }) => { 

    // progressData = progressData?.filter((item) => item.barValue >= 0 && item.name !== 'Machine Guard')?.sort((a, b) => {
    //     if (a.alerts !== b.alerts) {
    //         return b.alerts - a.alerts
    //     }
    //     return a.barValue - b.barValue
    // }) 
    const [tooltipOpen, setTooltipOpen] = useState({});
    const [role, setrole] = useState(JSON.parse(localStorage.getItem('role')))
    const [userID, setuserID] = useState(JSON.parse(localStorage.getItem('userData'))?.id || '')
    const [factoryID, setfactoryID] = useState(JSON.parse(localStorage.getItem('userData'))?.factory?.id || '');
    const [ToolTipData, setToolTipData] = useState({});
    const [loading, setloading] = useState(true)


    // if(factoryID==14){
    //   progressData = progressData.filter((item)=>item.name!=='No Go')
    // }

    //   progressData = progressData?.filter((item) => item.barValue >= 0 && item.name !== 'Machine Guard')?.sort((a, b) => {
    //     if (a.alerts !== b.alerts) {
    //         return b.alerts - a.alerts
    //     }
    //     return a.barValue - b.barValue
    // })

    const toggleTooltip = (id) => {
        setTooltipOpen((prev) => ({
            ...prev,
            [id]: !prev[id], // Toggle tooltip for the current progress bar
        }));
    };
    async function fetchTooltipData() {
        try {
            setloading(true) 
            const finalPyaload = {
                ...filters,
                shift: filters?.shift || '',
                user_id: userID,
                factory_id: factoryID,
                week: filters?.weekly,
                "area_id": "",
                "areas": [],
                "date": "",
                "starting": "",
                "ending": ''
            }
 
            await AreaService.getAINewCards(finalPyaload).then((res) => {
                const data = res?.data
                setToolTipData(data);
                setloading(false)
            })

        } catch (error) {
            console.log(error, 'error while fetching progress bar tooltip data')
        }
    }
    const getMappedName = (name) => {
        const nameMap = {
            "Emergency Exit": 'emergency_exit_blockage',
            "MMHE": 'forklift_person_in_same_aisle',
            "Machine Guard": "machine_guard_open",
            Helmet: "Helmet",
            Vest: "Vest",
        };
        return nameMap[name] || name;
    };
    useEffect(() => {
        fetchTooltipData()
    }, [filters])


    const isPernawan = JSON.parse(localStorage.getItem('userData'))?.factory?.id === 34
    return (
        <Card
            className="progressbarParent p-0 m-0 custom-scroll"
            style={{ boxShadow: "none", height: width < 1400 && "320px", overflow: width < 1400 && "auto" }}
        >
            <style jsx>{`
                .custom-scroll {
                    scrollbar-width: thin;
                    scrollbar-color: #ECECEC;
                    background-color: white;
                }
                .custom-scroll::-webkit-scrollbar {
                    width: 8px;
                }
            `}</style>

            {progressData ? (
                progressData.map((item, key) => (
                    <CardBody
                        className="py-2 mb-2  ps-0"
                        // style={{ borderTop: "1px solid #ececec" }}
                        key={key}
                    >
                        <>
                            <>
                                
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: '8px' }}>
                                        <div style={{ width: "70%" }}>
                                            <div className='d-flex gap-3'>
                                                <h5 style={{ fontSize: "16px" }}>
                                                    {item.name === "Emergency Exit" ? "E.Exit" : item.name}
                                                </h5>
                                                <p
                                                    style={{
                                                        color:
                                                            item.barValue === 100
                                                                ? "#54BA4A" // green
                                                                : item.barValue > 95
                                                                    ? "#FFC107" // amber
                                                                    : "#F44336" // red
                                                    }}
                                                    className='fw-semibold'>
                                                    {item.barValue}%
                                                </p>
                                            </div>


                                            <div className="mb-1" style={{ width: "100%" }}>
                                                <Progress
                                                    id={`progress_${key}`}
                                                    value={item.barValue}
                                                    color={
                                                        item.barValue === 100
                                                            ? "success"
                                                            : item.barValue < 100 && item.barValue > 95
                                                                ? "warning"
                                                                : item.barValue <= 95 ? "danger" : "danger"
                                                    }
                                                    style={{ height: "8px", cursor: "pointer" }}
                                                />

                                                {role && role !== "area" ? (
                                                    <Tooltip
                                                        placement="top"
                                                        isOpen={tooltipOpen[`progress_${key}`]}
                                                        target={`progress_${key}`}
                                                        toggle={() => toggleTooltip(`progress_${key}`)}
                                                        style={{
                                                            background: "#333333",
                                                            color: "white",
                                                            borderRadius: "5px",
                                                            padding: '5px'
                                                        }}
                                                    >
                                                        {loading ? 'Retrieving data...' : <>

                                                            {ToolTipData[getMappedName(item.name)] ? (
                                                                <>
                                                                    {/* <p className='text-start m-0' style={{fontSize:'12px'}}>
                                                                    Total Frames:  {ToolTipData[getMappedName(item.name)].total_frames}
                                                                </p> */}
                                                                    <p className='text-start m-0' style={{ fontSize: '12px' }}>
                                                                        Total Cameras:  {ToolTipData[getMappedName(item.name)].total_cameras}
                                                                    </p>
                                                                    <p className='text-start m-0' style={{ fontSize: '12px' }}>
                                                                        Total Events:  {ToolTipData[getMappedName(item.name)].total_event}
                                                                    </p>
                                                                    <p className='text-start m-0' style={{ fontSize: '12px' }}>
                                                                        Compliance:   {ToolTipData[getMappedName(item.name)].total_compliance}
                                                                    </p>
                                                                    <p className='text-start m-0' style={{ fontSize: '12px' }}>
                                                                        Non Compliance:  {ToolTipData[getMappedName(item.name)].total_alerts}
                                                                    </p>
                                                                </>
                                                            ) : (
                                                                <div>No data available</div>
                                                            )}
                                                        </>}
                                                    </Tooltip>
                                                ) : null}
                                            </div>
                                        </div>
                                        {/* <div style={{ display: "flex", alignItems: "center" }}>
                                           
                                            <span>{item.alerts || "0"}</span>
                                        </div> */}
                                        <div className="text-center border rounded px-2 py-1 ">
                                            <span style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>Total SBO : {item.alerts || "0"}</span>
                                        </div>

                                    </div>
                                    {/* <section>
                                        <div className="d-flex justify-content-between flex-wrap">
                                            <p className="m-0" style={{ color: "#8C8C8C", fontSize: "12px" }}>
                                                Max Alerts by: <span style={{ color: "black" }}>{item.area_owner || "N/A"}</span>
                                            </p>
                                            
                                        </div>
                                        <p className="m-0 p-0" style={{ color: "#8C8C8C", fontSize: "12px" }}>
                                            Sub Area: <span style={{ color: "black" }}>{item.subarea_with_max_alerts || "N/A"}</span>
                                        </p>
                                        
                                    </section> */}
                                    {/* <section className="border rounded mt-2 px-3 py-2 bg-white">
                                        <ul className="mb-1 ps-3" style={{ listStyleType: 'disc', color: '#8C8C8C', fontSize: '12px' }}>
                                            <li className="mb-1">
                                                Max Alerts by: <span className="fw-semibold text-dark">{item.area_owner || "N/A"}</span>
                                            </li>
                                            <li>
                                                Sub Area: <span className="fw-semibold text-dark">{item.subarea_with_max_alerts || "N/A"}</span>
                                            </li>
                                        </ul>
                                    </section> */}
                                    {console.log(item, 'item in progress bar tooltip')}
                                    <section className="tooltip-wrapper position-relative border rounded mt-2 px-3 py-2 bg-white">
                                        {/* <div className="tooltip custom-toolpit">
                                            Sub Area Max Alerts: {item?.max_alerts ?? "N/A"}
                                        </div> */}
                                        <ul className="mb-1 ps-3" style={{ listStyleType: 'disc', color: '#8C8C8C', fontSize: '12px' }}>

                                            {
                                                item?.alerts ? <li className="mb-1">
                                                    {`Max Alerts in ${areaFlag ? 'Subarea' : 'area'}:`} <span className="fw-semibold text-dark">{areaFlag ? item?.subarea_with_max_alerts + ', ' || 'N/A' : isPernawan ? item?.area_with_max_alerts : item?.area_owner || "N/A "} {`${item?.max_alerts || 0}/${item?.alerts || 0}`}
                                                    </span>
                                                </li> : <li className="mb-1">
                                                    No SBO  
                                                </li>
                                            }

                                        </ul>
                                    </section>



                                </>
                        </>
                    </CardBody>
                ))
            ) : (
                <p className='f-light text-center '>No data found</p>
            )}
        </Card>
    );


};

export default NewBarChart2;
